<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Quando si tratta di investire nel vino, ciò che gli investitori esperti devono cercare è la capacità di farlo
                        continuare a migliorare per decenni dopo l'imbottigliamento. La scarsità è un altro fattore che aumenterà
                        prezzi. Questa resilienza e longevità significa che i valori tenderanno ad apprezzarsi nel tempo,
                        a condizione che le bottiglie siano conservate correttamente.
                    </div>

                    <div class="howto-title2">100 anni di vinificazione</div>
                    <div class="howto-text">
                        Probabilmente la migliore azienda vinicola della Valle del Douro, Quinto do Castro è una singola tenuta di quinta (a conduzione familiare). Di una bellezza mozzafiato e storicamente ricca, la tenuta di 130 ettari ha recentemente (2015) festeggiato il suo 400° compleanno e può vantare lo status di Feitoria (la più alta classificazione dei vigneti del 17° secolo, un po' come la classificazione Cru francese). Tuttavia, la nostra attenzione è maggiormente catturata dagli ultimi 100 anni, quando Costantino de Almeida, socio della casa portuale di Costantino, acquistò la tenuta. Quattro generazioni dopo, sembra che la scommessa di Constantino abbia dato i suoi frutti.
                    </div>

                    <div class="howto-title2">Non la tipica miscela Douro</div>
                    <div class="howto-text">
                        Quello che era iniziato come un puro produttore di vino Porto si è trasformato nella produzione di alcuni dei vini del mondo
                        migliori vini da tavola portoghesi. Con Port che perde il favore tra le giovani generazioni, questo
                        ha permesso loro di espandere notevolmente il proprio portafoglio e ottenere un seguito internazionale. Nonostante
                        i loro vini di Porto sono tra le migliori esportazioni del paese, Quinto do Castro era tra i
                        pionieri del vino da tavola in Portogallo, e la loro Vinha da Ponte (disponibile solo nelle annate d'annata
                        e limitato a poche migliaia di bottiglie) ha raggiunto uno status leggendario. Questo è un
                        la scelta del collezionista quando si tratta di Quinto do Castro, ottenuto da viti di 80 anni e offerta
                        superbo invecchiamento. Dal 2010 sono state prodotte solo tre annate, vale a dire Vinha Da Ponte
                        ha raggiunto l'ambito status di avere sia la longevità che la scarsità.
                    </div>

                    <div class="howto-title2">Non si tratta solo di Bordeaux e Borgogna, sai</div>
                    <div class="howto-text">
                        Con gli investimenti nel vino in aumento di circa il 20% anno su anno, ha senso considerare tutto il potenziale
                        opzioni prima di separarti dai tuoi soldi. Vini francesi, in particolare le grandi tenute di Bordeaux
                        e la Borgogna detengono da tempo il primo posto nei cuori e nei portafogli degli investitori, ma con i prezzi
                        a dondolo, sembra che Quinto do Castro sia un valido contendente per la migliore opzione di investimento. In
                        vino, chiunque può indossare la corona.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn es darum geht, in Wein zu investieren, müssen kluge Anleger auf die Fähigkeit achten, dies zu tun
                        Er verbessert sich noch Jahrzehnte nach der Abfüllung weiter. Knappheit ist ein weiterer Faktor, der steigen wird
                        Preise. Diese Widerstandsfähigkeit und Langlebigkeit bedeutet, dass Werte im Laufe der Zeit tendenziell an Wert gewinnen.
                        vorausgesetzt, die Flaschen werden ordnungsgemäß gelagert.
                    </div>

                    <div class="howto-title2">100 Jahre Weinherstellung</div>
                    <div class="howto-text">
                        Quinto do Castro ist wohl das beste Weingut im Douro-Tal und ein einziges Quinta-Weingut (familiengeführt). Atemberaubend schön und historisch reich, feierte das 130 Hektar große Anwesen vor kurzem (2015) seinen 400. Geburtstag und kann den Feitoria-Status beanspruchen (die höchste Weinbergsklassifizierung des 17. Jahrhunderts, ähnlich der französischen Cru-Klassifizierung). Unsere Aufmerksamkeit gilt jedoch vor allem den letzten 100 Jahren, als Constantino de Almeida, ein Teilhaber des Portweinhauses von Constantino, das Anwesen kaufte. Vier Generationen später scheint sich Constantinos Risiko ausgezahlt zu haben.
                    </div>

                    <div class="howto-title2">Keine typische Douro-Mischung</div>
                    <div class="howto-text">
                        Was als reiner Portweinhersteller begann, hat sich zu einem Hersteller von Portweinen der Welt entwickelt
                        beste portugiesische Tischweine. Da Portwein bei den jüngeren Generationen in Ungnade fällt, ist dies der Fall
                        hat es ihnen ermöglicht, ihr Portfolio erheblich zu erweitern und eine internationale Fangemeinde zu gewinnen. Trotz
                        Ihre Portweine gehörten zu den besten Exporten des Landes, darunter auch Quinto do Castro
                        Pioniere des Tafelweins in Portugal und ihr Vinha da Ponte (nur in Jahrgangsjahren erhältlich).
                        und auf nur wenige tausend Flaschen beschränkt) hat legendären Status erreicht. Das ist ein
                        Die Wahl für Sammler, wenn es um Quinto do Castro geht, hergestellt aus 80 Jahre alten Reben und Angeboten
                        hervorragende Alterung. Seit 2010 wurden nur drei Jahrgänge produziert, nämlich Vinha Da Ponte
                        hat den begehrenswerten Status erreicht, sowohl Langlebigkeit als auch Knappheit zu haben.
                    </div>

                    <div class="howto-title2">Wie Sie wissen, geht es nicht nur um Bordeaux und Burgund</div>
                    <div class="howto-text">
                        Da die Investitionen in Wein im Vergleich zum Vorjahr um etwa 20 % gestiegen sind, ist es sinnvoll, alle Potenziale zu prüfen
                        Optionen, bevor Sie sich von Ihrem Geld trennen. Französische Weine, insbesondere die großen Weingüter von Bordeaux
                        und Burgund nehmen seit langem den ersten Platz in den Herzen und Geldbörsen der Anleger ein, allerdings mit Preisen
                        Es scheint, dass Quinto do Castro ein ernstzunehmender Anwärter auf die beste Anlageoption ist. In
                        Wein, jeder kann die Krone tragen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Lorsqu'il s'agit d'investir dans le vin, ce que les investisseurs avisés doivent rechercher, c'est la capacité de
                        continuer à s'améliorer pendant des décennies après la mise en bouteille. La rareté est un autre facteur qui augmentera
                        des prix. Cette résilience et cette longévité signifient que les valeurs auront tendance à s'apprécier avec le temps,
                        à condition que les bouteilles soient correctement stockées.
                    </div>

                    <div class="howto-title2">100 ans de vinification</div>
                    <div class="howto-text">
                        Sans doute le meilleur domaine viticole de la vallée du Douro, Quinto do Castro est un domaine unique de quinta (géré par une famille). D'une beauté à couper le souffle et d'une richesse historique, le domaine de 130 hectares a récemment (2015) fêté ses 400 ans et peut revendiquer le statut de Feitoria (la plus haute classification de vignoble du 17ème siècle, un peu comme la classification des crus français). Cependant, notre attention est surtout captée par les 100 dernières années, lorsque Constantino de Almeida, un associé de la maison portuaire de Constantino, a acheté le domaine. Quatre générations plus tard, il semble que le pari de Constantino ait porté ses fruits.
                    </div>

                    <div class="howto-title2">Pas votre mélange typique du Douro</div>
                    <div class="howto-text">
                        Ce qui a commencé comme un pur fabricant de vin de Porto s'est transformé en produisant certains des meilleurs vins du monde.
                        meilleurs vins de table portugais. Le Porto tombant en disgrâce auprès des jeunes générations, ce
                        leur a permis d'élargir considérablement leur portefeuille et de gagner un public international. Malgré
                        leurs vins de Porto étant parmi les meilleures exportations du pays, Quinto do Castro était parmi les
                        pionniers du vin de table au Portugal, et leur Vinha da Ponte (uniquement disponible dans les millésimes
                        et limité à quelques milliers de bouteilles seulement) a atteint un statut légendaire. C'est un
                        le choix du collectionneur en matière de Quinto do Castro, issu de vieilles vignes de 80 ans et offrant
                        superbe vieillissement. Seuls trois millésimes ont été produits depuis 2010, ce qui signifie que Vinha Da Ponte
                        a atteint le statut convoité d'avoir à la fois longévité et rareté.
                    </div>

                    <div class="howto-title2">Il ne s'agit pas uniquement de Bordeaux et de la Bourgogne, vous savez</div>
                    <div class="howto-text">
                        Avec des investissements dans le vin en hausse d'environ 20% d'une année sur l'autre, il est logique d'examiner tout le potentiel
                        options avant de se séparer de votre argent. Les vins français, notamment les grands domaines bordelais
                        et la Bourgogne ont longtemps occupé la première place dans le cœur et le portefeuille des investisseurs, mais avec des prix
                        bascule, il semble que Quinto do Castro soit un candidat viable pour la meilleure option d'investissement. Dans
                        vin, n'importe qui peut porter la couronne.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Quinta do Crasto</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        When it comes to investing in wine, what savvy investors need to look for is the capacity to
                        continue improving for decades after bottling. Scarcity is another factor that will raise
                        prices. This resilience and longevity means that values will tend to appreciate over time,
                        provided bottles are properly stored.
                    </div>

                    <div class="howto-title2">100 years of winemaking</div>
                    <div class="howto-text">
                        Arguably the finest wine estate in the Douro Valley, Quinto do Castro is a single quinta (family-run) estate. Breathtakingly beautiful and historically rich, the 130-hectacre estate has recently (2015) celebrated its 400th birthday and can claim Feitoria status (the highest vineyard classification of the 17th century, rather like the French Cru classification). However, our attention is most captured by the last 100 years, when Constantino de Almeida, a partner in the Port house of Constantino, bought the estate. Four generations later, it looks like Constantino’s gamble has paid off.
                    </div>

                    <div class="howto-title2">Not your typical Douro blend</div>
                    <div class="howto-text">
                        What started out as a pure Port wine manufacturer has morphed into producing some of the world’s
                        best Portuguese table wines. With Port falling out of favour among the younger generations, this
                        has allowed them to greatly expand their portfolio and gain an international following. Despite
                        their Port wines being some of the best exports of the country, Quinto do Castro was among the
                        pioneers of table wine in Portugal, and their Vinha da Ponte (only available in vintage years
                        and restricted to only a few thousand bottles) has reached legendary status. This is a
                        collector’s choice when it comes to Quinto do Castro, made from 80-year old vines and offering
                        superb ageing. Only three vintages have been produced since 2010, meaning that Vinha Da Ponte
                        has reached the covetable status of having both longevity and scarcity.
                    </div>

                    <div class="howto-title2">It’s not all about Bordeaux and Burgundy you know</div>
                    <div class="howto-text">
                        With investing in wine up about 20% year on year, it makes sense to look at all potential
                        options before parting with your cash. French wines, particularly the great estates of Bordeaux
                        and Burgundy have long held the first place in investor’s hearts and wallets, but with prices
                        rocking, it seems that Quinto do Castro is a viable contender for the best investing option. In
                        wine, anyone can wear the crown.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuintaDoCrasto",
    data() {
        return {
            select: {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Quinta do Crasto | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Quinta do Crasto, a renowned wine producer in the Douro Valley region of Portugal. With a commitment to quality and tradition, Quinta do Crasto creates world-class red, white, and port wines that are sure to impress.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
